import { lazy } from 'react';

export const importApply = () => import('pages/Apply/Apply');
export const importReinstatementApply = () => import('pages/Apply/ReinstatementApply');
export const importStarlingApply = () => import('pages/Apply/StarlingApply');
export const importDocumentVerification = () => import('pages/DocumentVerification');
export const importDocumentVerificationResult = () => import('pages/DocumentVerificationResult');
export const importNotFound = () => import('pages/NotFound');
export const importNotification = () => import('pages/Notification');
export const importReview = () => import('pages/Review');
export const importVerify = () => import('pages/Verify');

export const ApplyPage = lazy(importApply);
export const DocumentVerificationPage = lazy(importDocumentVerification);
export const DocumentVerificationResultPage = lazy(importDocumentVerificationResult);
export const NotFoundPage = lazy(importNotFound);
export const NotificationPage = lazy(importNotification);
export const ReinstatementApplyPage = lazy(importReinstatementApply);
export const ReviewPage = lazy(importReview);
export const StarlingApplyPage = lazy(importStarlingApply);
export const VerifyPage = lazy(importVerify);

export const prefetchFinalPages = () => {
  void importDocumentVerification();
  void importDocumentVerificationResult();
  void importNotification();
  void importReview();
  void importVerify();
  void import('pages/Notification/prefetchFinalAssets').then((module) => {
    module.prefetchFinalAssets();
  });
};
